"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ReviewLesson_exports = {};
__export(ReviewLesson_exports, {
  default: () => ReviewLesson_default
});
module.exports = __toCommonJS(ReviewLesson_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 10.6211C10.9427 10.2305 11.3919 9.88542 11.8477 9.58594C12.3164 9.28646 12.7917 9.03255 13.2734 8.82422C13.7682 8.60286 14.2695 8.42708 14.7773 8.29688C15.2982 8.16667 15.8255 8.08203 16.3594 8.04297C16.3724 8.04297 16.3854 8.04297 16.3984 8.04297C16.4115 8.04297 16.418 8.04297 16.418 8.04297C16.6263 8.04297 16.8021 8.11458 16.9453 8.25781C17.0885 8.40104 17.1602 8.57682 17.1602 8.78516V15.4648C17.1602 15.6471 17.1016 15.8099 16.9844 15.9531C16.8672 16.0964 16.7109 16.181 16.5156 16.207C15.1615 16.3893 14.0417 16.5977 13.1562 16.832C12.2839 17.0534 11.6458 17.3073 11.2422 17.5938C11.099 17.6979 10.8516 17.75 10.5 17.75C10.1484 17.75 9.90104 17.6979 9.75781 17.5938C9.35417 17.3073 8.70964 17.0469 7.82422 16.8125C6.95182 16.5781 5.83854 16.3763 4.48438 16.207C4.30208 16.181 4.14583 16.0964 4.01562 15.9531C3.89844 15.8099 3.83984 15.6471 3.83984 15.4648V8.78516C3.83984 8.77214 3.83984 8.75911 3.83984 8.74609C3.83984 8.73307 3.83984 8.72656 3.83984 8.72656C3.85286 8.51823 3.9375 8.34896 4.09375 8.21875C4.25 8.08854 4.43229 8.02995 4.64062 8.04297C5.17448 8.08203 5.69531 8.16667 6.20312 8.29688C6.72396 8.42708 7.22526 8.60286 7.70703 8.82422C8.20182 9.03255 8.67708 9.28646 9.13281 9.58594C9.60156 9.88542 10.0573 10.2305 10.5 10.6211ZM10.5 8.00391C9.88802 8.00391 9.36068 7.78906 8.91797 7.35938C8.48828 6.92969 8.27344 6.40885 8.27344 5.79688C8.27344 5.1849 8.48828 4.66406 8.91797 4.23438C9.36068 3.80469 9.88802 3.58984 10.5 3.58984C11.112 3.58984 11.6328 3.80469 12.0625 4.23438C12.5052 4.66406 12.7266 5.1849 12.7266 5.79688C12.7266 6.40885 12.5052 6.92969 12.0625 7.35938C11.6328 7.78906 11.112 8.00391 10.5 8.00391Z",
      fill: "currentColor"
    }
  )
);
const SvgReviewLesson = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ReviewLesson_default = SvgReviewLesson;
